import {
  RecommendationCategory,
  UserRecommendedCategoryFeedResponse,
} from "@/schemas/user/explore";
import { UserImageType } from "@/schemas/user/image";

export const PLACEHOLDER_DATA: UserRecommendedCategoryFeedResponse = {
  categories: [
    {
      jobId: "marketing-job-id",
      category: RecommendationCategory.TRENDING,
      rank: 0,
      items: {
        next: null,
        items: [
          {
            id: "MKT001",
            rank: 1,
            username: "user1",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user1-preview.webp",
                url: "https://example.com/images/user1.webp",
              },
              id: "mkt-001",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user1",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT002",
            rank: 2,
            username: "user2",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user2-preview.webp",
                url: "https://example.com/images/user2.webp",
              },
              id: "mkt-002",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user2",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT003",
            rank: 3,
            username: "user3",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user3-preview.webp",
                url: "https://example.com/images/user3.webp",
              },
              id: "mkt-003",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user3",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
        ],
        total: 3,
      },
    },
    {
      jobId: "marketing-job-id",
      category: RecommendationCategory.DATING,
      rank: 1,
      items: {
        next: null,
        items: [
          {
            id: "MKT001",
            rank: 1,
            username: "user1",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user1-preview.webp",
                url: "https://example.com/images/user1.webp",
              },
              id: "mkt-001",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user1",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT002",
            rank: 2,
            username: "user2",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user2-preview.webp",
                url: "https://example.com/images/user2.webp",
              },
              id: "mkt-002",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user2",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT003",
            rank: 3,
            username: "user3",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user3-preview.webp",
                url: "https://example.com/images/user3.webp",
              },
              id: "mkt-003",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user3",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
        ],
        total: 3,
      },
    },
    {
      jobId: "marketing-job-id",
      category: RecommendationCategory.FRIENDS,
      rank: 2,
      items: {
        next: null,
        items: [
          {
            id: "MKT001",
            rank: 1,
            username: "user1",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user1-preview.webp",
                url: "https://example.com/images/user1.webp",
              },
              id: "mkt-001",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user1",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT002",
            rank: 2,
            username: "user2",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user2-preview.webp",
                url: "https://example.com/images/user2.webp",
              },
              id: "mkt-002",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user2",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT003",
            rank: 3,
            username: "user3",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user3-preview.webp",
                url: "https://example.com/images/user3.webp",
              },
              id: "mkt-003",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user3",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
        ],
        total: 3,
      },
    },
    {
      jobId: "marketing-job-id",
      category: RecommendationCategory.NEW_USERS,
      rank: 3,
      items: {
        next: null,
        items: [
          {
            id: "MKT001",
            rank: 1,
            username: "user1",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user1-preview.webp",
                url: "https://example.com/images/user1.webp",
              },
              id: "mkt-001",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user1",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT002",
            rank: 2,
            username: "user2",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user2-preview.webp",
                url: "https://example.com/images/user2.webp",
              },
              id: "mkt-002",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user2",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT003",
            rank: 3,
            username: "user3",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user3-preview.webp",
                url: "https://example.com/images/user3.webp",
              },
              id: "mkt-003",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user3",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
        ],
        total: 3,
      },
    },
    {
      jobId: "marketing-job-id",
      category: RecommendationCategory.ONLINE_NOW,
      rank: 4,
      items: {
        next: null,
        items: [
          {
            id: "MKT001",
            rank: 1,
            username: "user1",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user1-preview.webp",
                url: "https://example.com/images/user1.webp",
              },
              id: "mkt-001",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user1",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT002",
            rank: 2,
            username: "user2",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user2-preview.webp",
                url: "https://example.com/images/user2.webp",
              },
              id: "mkt-002",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user2",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT003",
            rank: 3,
            username: "user3",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user3-preview.webp",
                url: "https://example.com/images/user3.webp",
              },
              id: "mkt-003",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user3",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
        ],
        total: 3,
      },
    },
    {
      jobId: "marketing-job-id",
      category: RecommendationCategory.NEARBY,
      rank: 5,
      items: {
        next: null,
        items: [
          {
            id: "MKT001",
            rank: 1,
            username: "user1",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user1-preview.webp",
                url: "https://example.com/images/user1.webp",
              },
              id: "mkt-001",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user1",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT002",
            rank: 2,
            username: "user2",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user2-preview.webp",
                url: "https://example.com/images/user2.webp",
              },
              id: "mkt-002",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user2",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
          {
            id: "MKT003",
            rank: 3,
            username: "user3",
            image: {
              attributes: {
                height: 800,
                width: 600,
                previewUrl: "https://example.com/images/user3-preview.webp",
                url: "https://example.com/images/user3.webp",
              },
              id: "mkt-003",
              likeCount: 0,
              type: UserImageType.PUBLIC_IMAGE,
              username: "user3",
            },
            matchingPercentage: null,
            scores: [],
            highlights: [],
            commonInterests: [],
            distance: null,
            profileAttributes: {
              aboutMe: null,
              birthday: null,
              bodyType: null,
              ethnicity: null,
              height: null,
              weight: null,
              relationship: null,
              role: null,
              residence: null,
              seeking: [],
              languages: [],
              interests: [],
            },
            isLocked: false,
          },
        ],
        total: 3,
      },
    },
  ],
  jobId: "marketing-job-id",
  nextRefreshTime: new Date(Date.now() + 15 * 60 * 1000), // 15 min from now
};
